import { render } from "./ModalChooseClub.vue?vue&type=template&id=3ebe1687&scoped=true&ts=true"
import script from "./ModalChooseClub.vue?vue&type=script&lang=ts"
export * from "./ModalChooseClub.vue?vue&type=script&lang=ts"

import "./ModalChooseClub.vue?vue&type=style&index=0&id=3ebe1687&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebe1687"]])

export default __exports__